import { useState } from 'react';
import { css, mediaQueries } from '@eti/styles';
import { m as motion } from 'framer-motion';
import SimpleVisaNextStepInfo from '../components/SimpleVisaNextStepInfo';
import TravelerSelection from './TravelerSelection';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const nextStepStyles = css`
  padding-bottom: 32px;
  padding-inline-start: 0;
  padding-top: 16px;

  @media ${mediaQueries.small.only} {
    padding-inline: 16px;
  }
`;
const listStyles = css`
  margin-top: 0;
`;
const wrapperStyles = css`
  grid-area: 5 / 1 / 6 / 3;
  overflow: hidden;

  @media ${mediaQueries.medium.up} {
    margin-inline-start: auto;
    width: 70%;
  }
`;
const SimpleVisaContent = _ref => {
  let {
    contactEmail,
    isOpen,
    productName,
    travelers,
    selectAllTravelers
  } = _ref;
  const [isAnimating, setIsAnimating] = useState(false);
  return /*#__PURE__*/_jsxs(motion.div, {
    animate: {
      display: isOpen ? 'block' : 'none',
      height: isOpen ? 'auto' : 0,
      overflow: isOpen ? 'visible' : 'hidden'
    },
    className: wrapperStyles,
    "data-testid": "simpleVisa-content",
    initial: "false",
    onAnimationComplete: () => {
      selectAllTravelers();
      setIsAnimating(false);
    },
    onAnimationStart: () => setIsAnimating(true),
    transition: {
      type: 'tween'
    },
    children: [/*#__PURE__*/_jsx("div", {
      className: listStyles,
      children: travelers.map((traveler, index) => /*#__PURE__*/_jsx(TravelerSelection, {
        isAnimationComplete: !isAnimating && isOpen,
        productName: productName,
        traveler: traveler
      }, index))
    }), /*#__PURE__*/_jsx(SimpleVisaNextStepInfo, {
      className: nextStepStyles,
      contactEmail: contactEmail
    })]
  });
};
export default SimpleVisaContent;
//# sourceMappingURL=SimpleVisaContent.js.map